const path = '/order-management/document-package';

export const goGetDocuments = (documentIds: Array<string>, orderId: string) => {
  const documentIdsToSend =
    documentIds.length > 0 ? documentIds.join(',') : null;
  window.open(
    `/view-file?OrderId=${orderId}&path=${path}${
      documentIdsToSend ? `&DocumentIds=${documentIdsToSend}` : ''
    }`
  );
};

export const goGetDocumentsType = (type: string, orderId: string) => {
  window.open(
    `/view-file?OrderId=${orderId}${
      type ? `&SigningTypes=${type}` : ''
    }&path=${path}`
  );
};
